import React from 'react';
import { rightarrow, user, mail, report, plus, location, calendar, participant } from '../../assets/Exportimageicon';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Pagination from "../../Components/pagination/Pagination";
const { apiGet } = require('../../Services/Services');

const transactionsData = [
    {
        id: "ORD-2026-001",
        title: "A-75384",
        date: "20/04/2026",
        user: "Sarah Chen",
        mission: "Urban Mapping Project",
        amount: "125.00",
        currency: "SGD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-002",
        date: "20/04/2026",
        user: "Marcus Johnson",
        mission: "Coastal Survey",
        amount: "89.50",
        currency: "USD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-003",
        date: "19/04/2026",
        user: "Jennifer Martinez",
        mission: "Forest Trail Documentation",
        amount: "156.00",
        currency: "SGD",
        method: "Stripe",
        status: "Refunded",
    },
    {
        id: "ORD-2026-004",
        date: "19/04/2026",
        user: "Robert Taylor",
        mission: "Mountain Range Assessment",
        amount: "72.30",
        currency: "USD",
        method: "Stripe",
        status: "Failed",
    },
    {
        id: "ORD-2026-005",
        date: "18/04/2026",
        user: "Diana Prince",
        mission: "Lake Perimeter Study",
        amount: "103.80",
        currency: "SGD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-006",
        date: "18/04/2026",
        user: "Bruce Wayne",
        mission: "City Infrastructure Audit",
        amount: "198.00",
        currency: "USD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-007",
        date: "17/04/2026",
        user: "Clark Kent",
        mission: "Agricultural Land Survey",
        amount: "145.50",
        currency: "SGD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-008",
        date: "17/04/2026",
        user: "Barry Allen",
        mission: "Historic District Mapping",
        amount: "67.00",
        currency: "USD",
        method: "Stripe",
        status: "Failed",
    },
    {
        id: "ORD-2026-009",
        date: "16/04/2026",
        user: "Hal Jordan",
        mission: "Coastal Erosion Study",
        amount: "112.00",
        currency: "SGD",
        method: "Stripe",
        status: "Success",
    },
    {
        id: "ORD-2026-010",
        date: "16/04/2026",
        user: "Arthur Curry",
        mission: "Marine Protected Area Survey",
        amount: "185.00",
        currency: "USD",
        method: "Stripe",
        status: "Refunded",
    },
];

export default function MissionView() {

//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;


// const indexOfLastItem = currentPage * itemsPerPage;
// const indexOfFirstItem = indexOfLastItem - itemsPerPage;


//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [data, setData] = useState({});


// const participants =
//   data?.activeParticipants?.length > 0
//     ? data.activeParticipants
//     : staticParticipants;

// const currentData = participants.slice(
//   indexOfFirstItem,
//   indexOfLastItem
// );

// const totalPages = Math.ceil(participants.length / itemsPerPage);


    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(5);
    // const itemsPerPage = 5;

    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({});

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // API OR fallback
    const participants = data?.activeParticipants || [];

    const finalParticipants =
    participants.length > 0 ? participants : [];

    // // pagination data
    // const currentData = finalParticipants.slice(
    // indexOfFirstItem,
    // indexOfLastItem
    // );

    // const totalPages = Math.ceil(finalParticipants.length / itemsPerPage);

    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

    const currentData = finalParticipants.slice(
    indexOfFirstItem,
    indexOfLastItem
    );

    const totalPages = Math.ceil(
    finalParticipants.length / perPage
    );

    const start =
    participants.length === 0
        ? 0
        : indexOfFirstItem + 1;

    const end =
    Math.min(
        indexOfLastItem,
        participants.length
    );
    // reset page on data change
    useEffect(() => {
    setCurrentPage(1);
    }, [data]);

    console.log("idd", id)

    useEffect(() => {
        fetchDetail();
    }, [])

    const fetchDetail = async () => {
        try {
            const res = await apiGet(`/admin/challenges-Details/${id}`);
            setData(res.data);

            console.log(res.data);

        } catch (error) {
            console.error(error);
        }
    };

    const hanglemarketing = () => {
        navigate("/missions")
    }
    return (
        <>
            {/* Main Container Card */}

            {/* Campaign Content Area */}
            <div className="content-area">

                {/* Top Action Bar */}
                <div className="action-bar">
                    <div className="left-actions">
                        <button onClick={hanglemarketing} className="back-btn">
                            <img src={rightarrow} alt="" />
                            Back
                        </button>
                        <h2 className="campaign-title">{data?.challengeName}</h2>
                    </div>
                    <button className="marketing__create-btn" onClick={() => navigate(`/edit-mission/${id}`)}>
                        Edit Mission
                    </button>
                </div>

                {/* Stats Grid */}
                <div className="stats-grid">
                    {/* Box 1 */}
                    <div className="stat-box">
                        <div className="stat-header">
                            <img src={location} alt="" />
                            <span>Location</span>
                        </div>
                        <div className="stat-value">{data.location}</div>
                    </div>

                    {/* Box 2 */}
                    <div className="stat-box">
                        <div className="stat-header">
                            <img src={calendar} alt="" />
                            <span>Duration</span>
                        </div>
                        <div className="stat-value">{data.duration}</div>
                    </div>

                    {/* Box 3 */}
                    <div className="stat-box">
                        <div className="stat-header">
                            <img src={participant} alt="image" />
                            <span>Participants</span>
                        </div>
                        <div className="stat-value">{data.participants}</div>
                    </div>

                </div>

                {/* Campaign Details Section */}
                <div className="details-box">
                    <h3 className="details-title">Description</h3>
                    <p className="settings__subtitle">
                        {data.description}
                    </p>

                    <hr />

                    <h3 className="details-title">Mission Milestones</h3>

                    <div className="milestones">
                        {data?.milestones && data.milestones.length > 0 ? (
                            data.milestones.map((step, index) => (
                                <div key={index} className="milestone-item">
                                    <span className="milestone-badge">
                                        {index + 1}. {step}
                                    </span>

                                    {index !== data.milestones.length - 1 && (
                                        <span className="arrow">→</span>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>No milestones available.</p>
                        )}
                    </div>
                </div>

                <div className="details-box">
                    <h3 className="details-title">Active Participants
                    </h3>

                    <table className="custom-data-table">
                        <thead>
                            <tr>
                                <th>Participant Name</th>
                                <th>Current Milestone</th>
                                <th>Distance Covered (in Km)</th>
                                <th>Joined At</th>
                                <th>Progress Percentage</th>
                            </tr>
                        </thead>

                        {/* <tbody>
                            {data?.activeParticipants && data?.activeParticipants?.length > 0 ? (
                                // data.activeParticipants.map((row) => (
                                //     <tr key={row.id}>
                                //         <td className="col-user-name">{row.participantName}</td>
                                //         <td>{row.currentMilestone}</td>
                                //         <td>
                                //             <span className="badge-stripe">{row.distanceCovered}</span>
                                //         </td>

                                //         <td>

                                //             {row.joinedAt?.split("T")[0]}
                                //         </td>

                                //         <td>
                                //             <span className="badge-stripe">{row.progressPercentage}</span>
                                //         </td>


                                //     </tr>
                                // ))
                                {currentData.map((row) => (
                                    <tr key={row.id}>
                                        <td className="col-user-name">{row.participantName}</td>
                                        <td>{row.currentMilestone}</td>
                                        <td>
                                        <span className="badge-stripe">{row.distanceCovered}</span>
                                        </td>
                                        <td>{row.joinedAt.split("T")[0]}</td>
                                        <td>
                                        <span className="badge-stripe">{row.progressPercentage}</span>
                                        </td>
                                    </tr>
                                    ))}
                            ) : (
                                <tr>
                                    <td colSpan="8">No active participants available.</td>
                                </tr>
                            )}
                        </tbody> */}
                        <tbody>
                 {currentData && currentData.length > 0 ? (
                currentData?.map((row) => (
                <tr key={row.id}>
                    <td className="col-user-name">{row.participantName}</td>
                    <td>{row.currentMilestone}</td>
                    <td>
                    <span className="badge-stripe">{row.distanceCovered}</span>
                    </td>
                    <td>{row.joinedAt?.split("T")[0]}</td>
                    <td>
                    <span className="badge-stripe">{row.progressPercentage}</span>
                    </td>
                </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan="5" className="text-center">
                            No active participants available.
                        </td>
                        </tr>
                    )}
                    </tbody>
                    </table>
                   {/* <div className="pagination">
                        <button
                            className="page-btn"
                            disabled={currentPage <= 1}
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        >
                            Prev
                        </button>

                        {totalPages > 0 &&
                            Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                            ))}

                        <button
                            className="page-btn"
                            disabled={currentPage >= totalPages}
                            onClick={() =>
                            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                            }
                        >
                            Next
                        </button>
                        </div> */}
                        <Pagination

                            variant="full"

                            summary={`Showing ${start}-${end} of ${participants.length}`}

                            page={currentPage}

                            totalPages={totalPages}

                            totalCount={participants.length}

                            perPage={perPage}


                            onPageChange={(nextPage)=>
                            setCurrentPage(
                                Math.max(
                                1,
                                Math.min(nextPage,totalPages)
                                )
                            )
                            }


                            onPerPageChange={(value)=>{

                            setPerPage(value);

                            setCurrentPage(1);

                            }}

                            />
                </div>


            </div>
        </>
    );
}